import { configure } from '@/util/container';

export default configure(() => import(/* webpackMode: "eager" */ 'vue-select/dist/vue-select.css'));
